import React from "react";
import {connect} from "react-redux";
import moment from "moment";
import Container from "reactstrap/lib/Container";
import HomeTopCard from "./HomeTopCard";
import MaintenanceBottomCard from "./Maintenance/BottomCategory";
import FormMaintenance from './Form/FormMaintenance';
import FormMaintenanceCategory from './Form/FormMaintenanceCategory';
import FormMaintenanceTransaction from './Form/FormMaintenanceTransaction';

class MaintenancePage extends React.Component {
	 constructor(props){
        super(props);
        this.state ={
        addbooking : false, 
  			numbooking : null, 
  			bookingroomid : null, 
  			bookingroomdata : {}, 
  			bookingroomdate : new Date(), 
  			defaulttoday:new Date(),
        defaultstarted:null,
        defaultended:null,
  			choicestarted : new Date(),
  			choiceended : new Date(),
  			maintenanceid: null,
        maintenancename:'',
        addmaintenance:false,
      	addmaintenancecategory:false,
      	addmaintenancetransaction:false,
      	nummaintenance:null,
      	nummaintenancecategory:null,
      	nummaintenancetransaction:null,
      	categoryid:null,
        categoryname:''
        }
     }

     componentDidMount()
     {
	      let dt = new Date();
	      let firstday = new Date(dt.getFullYear(), dt.getMonth(), 1);
	      let lastday = new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
	      this.setState({
	         defaultstarted: moment(firstday).format("YYYY-MM-DD"),
	         defaultended: moment(lastday).format("YYYY-MM-DD")
	      })
     }
    


	render(){
		let { 
				addbooking, 
				numbooking, 
				bookingroomid, 
				bookingroomdata, 
				bookingroomdate,
				choicestarted,
				choiceended,
				defaultstarted,
    		defaultended,
    		maintenanceid,
        maintenancename,
        addmaintenance,
      	addmaintenancecategory,
      	addmaintenancetransaction,
      	nummaintenance,
      	nummaintenancecategory,
      	nummaintenancetransaction,
      	categoryid,
    		categoryname

			 } = this.state || '';


		return(
			<>
			{addmaintenance ? <FormMaintenance st={addmaintenance} st1={nummaintenance} handleClose={()=>this.setState({addmaintenance:false})} />:''}
            {addmaintenancecategory ? <FormMaintenanceCategory st={addmaintenancecategory} st1={nummaintenancecategory} handleClose={()=>this.setState({addmaintenancecategory:false})} />:''}
            {addmaintenancetransaction ? <FormMaintenanceTransaction st={addmaintenancetransaction} st1={nummaintenancetransaction} handleClose={()=>this.setState({addmaintenancetransaction:false})} /> : ''}
			<Container style={{position:'relative'}}>
                <>
                <div style={{minHeight:'50px'}}>
                </div>
                  <HomeTopCard  
                      id={0}
                      title={'Staff '}
                      icon={'fa fa-maintenance'}
                      handleBooking={(roomid, roomdata, roomdate, rowid)=>this.setState({
                          addbooking:true,
                          numbooking:rowid,
                          bookingroomid:roomid,
                          bookingroomdata:roomdata,
                          bookingroomdate:roomdate
                      })}
                      setDate={(start, end)=>this.setState({choicestarted:start, choiceended:end})}
                      />
                  <MaintenanceBottomCard 
                      id={1}
                      categoryid={categoryid}
                      categoryname={categoryname}
                      maintenanceid={maintenanceid}
                      maintenancename={maintenancename}
                      choicestarted={choicestarted}
                      choiceended={choiceended}
                      defaultstarted={defaultstarted}
                      defaultended={defaultended}
                      maintenanceAdd={(rid)=>this.setState({addmaintenance:true, nummaintenance:rid})}
                      maintenanceTransactionAdd={(rid)=>this.setState({addmaintenancetransaction:true, nummaintenancetransaction:rid})}
                      />
                </>
             </Container>
             </>

		)
	}

}
const mapStateToProps = (state, ownprop) =>({
  

})
export default connect(mapStateToProps, {})(MaintenancePage);